import React from 'react';

export const CompanyCaseStudies: React.FC = () => {
  return <div>CompanyCaseStudies</div>;
};
